<template lang="html">
  <button tabindex="0" :aria-description="$t('cci_section_item_aria_description')" class="section-swiper-slide section-bar-font" @click="changePage" @focus="isInFocus" @keydown.enter="changePage">
    {{ section.name }}
  </button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['section', 'index'],
  data () {
    return {}
  },
  mounted () {
    this.setColors()
  },
  computed: {
    ...mapGetters({
      currentSection: 'getCurrentSection',
      sections: 'getSections',
      currentPage: 'getCurrentPage'
      // sportsXtraMenuSelected: 'getSportsExtraMenuSelected'
    })
  },
  watch: {
    currentSection: function (newValue) {
      if (newValue === this.section) {
        this.clearOtherSections()
        this.setSelectedColors()
      }
    },
    // sportsXtraMenuSelected: function (newValue) {
    //   if (newValue && this.section.name.toUpperCase() === 'SPORTSXTRA') {
    //     this.changePage()
    //     this.$store.commit('setSportsExtraMenuSelected', false)
    //   }
    // },
    '$route': function (newValue, oldValue) {
      if (oldValue.name === 'articles' || oldValue.name === 'articles-mobile') {
        this.$nextTick(function () {
          if (this.currentSection === this.section) {
            this.clearOtherSections()
            this.setSelectedColors()
          }
        })
      }
    },
    sections: {
      handler () {
        this.$nextTick(function () {
          this.setColors()
        })
      }, 
      deep: true      
    }
  },
  methods: {
    setColors () {
      if (this.currentSection !== undefined) {
        if (this.section === this.currentSection) {
          this.clearOtherSections()
          this.setSelectedColors()
        }
      }
    },
    changePage () {
      this.clearOtherSections()
      this.setSelectedColors()
      this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesGroupNavigationSelect', undefined, this.section.name)
      this.$store.commit('setTransitionToPage', this.section.pages[0])
      this.$store.commit('setCurrentSection', this.section)
    },
    setSelectedColors () {
     this.$el.classList.add('section-swiper-slide-selected')
    },
    clearOtherSections () {
      const sectionsElem = document.getElementsByClassName('section-swiper-slide')
      for (var i = 0; i < sectionsElem.length; i++) {
        sectionsElem[i].classList.remove('section-swiper-slide-selected')
      }
    },
    isInFocus() {
      // emit event to parent
      // we need this in order to slide to the item in focus when using tab key for navigation
      this.$emit('inFocus', this.index)
    }
  }
}
</script>

<style lang=scss>
@import 'helpers/_colors-and-mixins.scss';
.section-swiper-slide {
  float: left;
  height: 100%;
  margin: 0 1px 0 0;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: $wet-asphalt;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  // height: 37px;
  // line-height: 37px;
  font-size: 0.9rem;

  @include respond-to(phone){
    /* width:100px; */
  }
}
.section-swiper-slide-selected {
  color: $clouds;
  background-color: $wet-asphalt;
}
</style>
